import { render } from "./App.vue?vue&type=template&id=346a6898"
const script = {}

import "./App.vue?vue&type=style&index=0&id=346a6898&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__